// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260935/js/" + chunkId + "." + {"44":"639e9c45","225":"f6967a98","481":"c2acf997","486":"6b7ed374","770":"4589c442"}[chunkId] + ".0.1704416359807066.chunk.js";
};